import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { useRef } from 'react';

import { Tooltip } from '../../1_Atoms/Tooltip/Tooltip';

export const Alert = ({Id, Desc, ...props }) => {
    const [textDisplayed, setTextDisplayed] = React.useState(null);
    const [tooltipCont, setTooltipCont] = React.useState(null);
    const alertRef = useRef();

    let summaryCalculator = window.summaryCalculator

    const getTextDisplay = () => {
        if(Desc)
            return Desc;

        switch(summaryCalculator._currentStep) {
            case 1:
                if(summaryCalculator?._selectedModelYear?.incentives_banner)
                    return summaryCalculator?._selectedModelYear?.incentives_banner;
            default:                
                if(summaryCalculator?._selectedTrim?.incentives_banner)
                    return summaryCalculator?._selectedTrim?.incentives_banner;

                if(summaryCalculator?._selectedModelYear?.incentives_banner)
                    return summaryCalculator?._selectedModelYear?.incentives_banner;
        }

    }
    
    React.useEffect(() => {
        //console.log('ALERT BAR DISPLAY TEXT CHANGED');

        let tempHtml = getTextDisplay();
        tempHtml = tempHtml?.includes('<ToolTip>') ? tempHtml.split('<ToolTip>') : tempHtml;
        if(Array.isArray(tempHtml)){
            setTooltipCont(tempHtml[1]);
            tempHtml.splice(1, 1);
            tempHtml = tempHtml.join(' ');
        }
        setTextDisplayed(tempHtml);
    }, [summaryCalculator._selectedModelYear, summaryCalculator._selectedTrim]);


    if(!textDisplayed) 
        return <></>;
    
    function insertTooltip(){
        return (<Tooltip TooltipText={ReactHtmlParser(tooltipCont)} TooltipClasses="mz-svg--white" />)
    }
    return (
        <div className="mz-alert__item" id={Id} ref={alertRef}>
            {!tooltipCont &&  ReactHtmlParser(textDisplayed)}
            {tooltipCont && 
                <p>
                    {ReactHtmlParser(textDisplayed)}
                    {insertTooltip()}
                </p>
            }
        </div>
    );
};

export default Alert;

Alert.propTypes = {
    Id: PropTypes.string,
    Desc: PropTypes.string,
}

Alert.defaultProps = {
    Id:  'AlertID',
    Desc: '',
};